<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div
    class="flex items-center w-full px-4 py-3 dark:bg-n-blue-11/15 bg-n-blue-3"
  >
    <span class="text-sm dark:text-n-blue-11 text-n-blue-11">
      {{ t('COMPOSE_NEW_CONVERSATION.FORM.NO_INBOX_ALERT') }}
    </span>
  </div>
</template>
